import '../scss/app.scss';
import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

import { Foundation } from 'foundation-sites/js/foundation.core';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';
Foundation.addToJquery($);
Foundation.MediaQuery = MediaQuery;

// Init Foundation
$(document).foundation();

// Remove no-js class
document.body.classList.remove('no-js');

 // Remove preload class after page has fully loaded                                                                            
 $(window).on('load', function() {                                                                                              
  $('body').removeClass("preload");                                                                                            
});         


// Mobile menu
function toggleMenu() {
  const $mobileNav = $('.mobile-navigation');
  const $hamburger = $('.hamburger');
  const $mainNav = $('.primary-navigation');
  
  $mobileNav.toggleClass("active");
  $hamburger.toggleClass("is-active");
  $('body').toggleClass("menu-open");
  
  // Toggle visibility of main navigation on mobile
  if ($(window).width() < 1024) {
    $mainNav.toggleClass('hide-for-small-only');
  }

  if($mobileNav.hasClass("active")) {
    $('.page-header').append('<div class="menu-overlay"></div>');
    $('.menu-overlay').hide().fadeIn(200);
  } else {
    $('.menu-overlay').fadeOut(200, function () {
      $(this).remove();
    });
  }
}

// Hamburger icon
$(".hamburger").click(function() {
  toggleMenu();
});

// Menu overlay click
$(document).on('click','.toggle-menu', function(){
  $(this).next().toggleClass('show');
});

// Toggle menu
$(document).on('click','.menu-overlay', function(){
  toggleMenu();
});


// // Close mobile menu on anchor click
$('.mobile-menu a[href*="#"]').click(function() {
  toggleMenu();
});

// Scroll function
function scroll_to(target, speed) {
  var scroll = target.offset().top;

  $('html, body').animate({
      scrollTop: scroll
  }, speed, 'easeInOutCubic');
}


// Handle scroll
$(document).ready(function(){
// Select all links with hashes
  $('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .click(function (event) {
      // On-page links
      if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
      ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
              // Only prevent default if animation is actually gonna happen
              event.preventDefault();
              scroll_to(target, 800);

              // Push hash in history state                    
              if (history.pushState) {
                  history.pushState(null, null, this.hash);
              }
              else {
                  location.hash = this.hash;
              }
          }
      }
  });
});

// Scroll to the current hash on load
function scroll_to_current_item_on_load() {
  var hash = location.hash;
  var target = $(hash);
  if (hash != "" && target.length) {
    scroll_to(target, 800);
  }
}

$(document).ready(function(){
  scroll_to_current_item_on_load();
});

// Typing effect
var TxtRotate = function(el, toRotate, period) {
  this.toRotate = toRotate;
  this.el = el;
  this.loopNum = 0;
  this.period = parseInt(period, 10) || 2000;
  this.txt = '';
  this.tick();
  this.isDeleting = false;
};

TxtRotate.prototype.tick = function() {
  var i = this.loopNum % this.toRotate.length;
  var fullTxt = this.toRotate[i];

  if (this.isDeleting) {
    this.txt = fullTxt.substring(0, this.txt.length - 1);
  } else {
    this.txt = fullTxt.substring(0, this.txt.length + 1);
  }

  this.el.innerHTML = '<span class="wrap">'+this.txt+'</span>';

  var that = this;
  var delta = 300 - Math.random() * 100;

  if (this.isDeleting) { delta /= 2; }

  if (!this.isDeleting && this.txt === fullTxt) {
    delta = this.period;
    this.isDeleting = true;
  } else if (this.isDeleting && this.txt === '') {
    this.isDeleting = false;
    this.loopNum++;
    delta = 1000;
    // setTimeout(function() {
    //   mySwiper.slideNext();
    // }, 250);
  }

  setTimeout(function() {
    that.tick();
  }, delta);
};

window.onload = function() {
  var elements = document.getElementsByClassName('text-animate');
  for (var i=0; i<elements.length; i++) {
    var toRotate = elements[i].getAttribute('data-rotate');
    var period = elements[i].getAttribute('data-period');
    if (toRotate) {
      new TxtRotate(elements[i], JSON.parse(toRotate), period);
    }
  }
};
